import waitFor from "@insite/client-framework/Common/Utilities/waitFor";
import { addToChainBefore, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { chain, DispatchSetWishListId, } from "@insite/client-framework/Store/Pages/StaticList/Handlers/LoadWishListIfNeeded";
import { getSharedQuoteId } from "@MasterBluePrint/Services/CustomQuoteService";

/* istanbul ignore next */
if (module.hot) {
    module.hot.accept();
    const originalChain = chain.slice();
    module.hot.dispose(data => {
        chain.length = 0;
        originalChain.forEach(o => chain.push(o));
    });
}

addToChainBefore(chain, DispatchSetWishListId, async props => {
    if (props.parameter.wishListId.length < 35) {
        let wishListId = "";
        let isLoaded = false;
        let isLoading = false;
        const checkData = () => {
            if (!isLoaded && !isLoading) {
                isLoading = true;
                const wishListIdPromise = getSharedQuoteId(props.parameter.wishListId);
                wishListIdPromise.then((result) => {
                    wishListId = result;
                    isLoaded = true;
                    isLoading = false;
                });
            }
            if (isLoaded && !isLoading) {
                return true;
            }
            return false;
        };
        await waitFor(checkData);
        if (wishListId !== "") {
            props.dispatch({
                type: "Pages/StaticList/SetWishListId",
                wishListId,
            });
        } else {
            return false;
        }
    }

});


replaceInChain(chain, DispatchSetWishListId, props => {
    if (props.parameter.wishListId.length < 35) {
        return false;
    }
    props.dispatch({
        type: "Pages/StaticList/SetWishListId",
        wishListId: props.parameter.wishListId,
    });
});